import service from '@/utils/request'

export const login = (data) => {
  return service({ url: "/base/login", method: 'post', data })
}

export const captcha = (data) => {
  return service({ url: "/base/captcha", method: 'post', data })
}

export const getBillList = (data) => {
  return service({ url: "/admin/trunk/getBillList", method: 'post', data })
}

export const getBillDailyStats = (data) => {
  return service({ url: "/admin/trunk/getBillDailyStats", method: 'post', data })
}

export const getIPWhitelistConfig = () => {
  return service({ url: "/sysmanage/getIPWhitelistConfig", method: 'post' })
}

export const setIPWhitelistConfig = (data) => {
  return service({ url: "/sysmanage/setIPWhitelistConfig", method: 'post', data })
}

export const getIPWhitelistList = () => {
  return service({ url: "/sysmanage/getIPWhitelistList", method: 'post' })
}

export const addIPWhitelist = (data) => {
  return service({ url: "/sysmanage/addIPWhitelist", method: 'post', data })
}

export const removeIPWhitelist = (data) => {
  return service({ url: "/sysmanage/removeIPWhitelist", method: 'post', data })
}

export const getLoginSecurityConfig = () => {
  return service({ url: "/sysmanage/getLoginSecurityConfig", method: 'post' })
}

export const setLoginSecurityConfig = (data) => {
  return service({ url: "/sysmanage/setLoginSecurityConfig", method: 'post', data })
}

export const getBannedIPList = () => {
  return service({ url: "/sysmanage/getBannedIPList", method: 'post' })
}

export const unbanIP = (data) => {
  return service({ url: "/sysmanage/unbanIP", method: 'post', data })
}

export const jsonInBlacklist = () => {
  return service({ url: "/jwt/jsonInBlacklist", method: 'post' })
}


// ==================== OA办公 ====================
export const oaPunchCheckin = (data) => {
  return service({ url: "/admin/oa/punchCheckin", method: 'post', data })
}

export const oaGetTodayPunch = () => {
  return service({ url: "/admin/oa/getTodayPunch", method: 'post' })
}

export const oaGetMyAttendance = (data) => {
  return service({ url: "/admin/oa/getMyAttendance", method: 'post', data })
}

export const oaSubmitLeave = (data) => {
  return service({ url: "/admin/oa/submitLeave", method: 'post', data })
}

export const oaGetMyLeaves = (data) => {
  return service({ url: "/admin/oa/getMyLeaves", method: 'post', data })
}


export const oaGetIPLocation = () => {
  return service({ url: "/admin/oa/getIPLocation", method: 'post' })
}


export const oaGetLocationList = () => {
  return service({ url: "/admin/oa/getLocationList", method: 'post' })
}


export const oaGetApproverList = () => {
  return service({ url: "/admin/oa/getApproverList", method: 'post' })
}
